import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/api.service';
import { environment } from '../../../environments/environment';

import { cAccountInfo, ChargeBeeProfileApiOutput } from 'src/app/shared/models/api/chargbeeprofile-api.model';
import { Store } from '@ngrx/store';
import { UserService } from 'src/app/core/user.service';
import * as fromRoot from '../../reducers';
import * as ChargebeeActions from '../../actions/chargebee-actions';
import { LoggerService } from 'src/app/core/logger.service';
import { Router } from '@angular/router';
import { BroadcastService } from './broadcast.service';
import { PermissionActions } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ChargebeeService {
  public chargebeeProfile: cAccountInfo;
  public userLimit: number;
  private isLoading = false;
  private chargebeeInstance: ChargebeeInstance;

  constructor(
    private apiService: ApiService,
    private store: Store<fromRoot.State>,
    private userService: UserService,
    private logger: LoggerService,
    private router: Router,
    private broadcastService: BroadcastService
  ) {
    this.chargebeeInstance = (window['Chargebee']).init({
      site: environment.chargebeeSite
    });
    this.broadcastService.on('sync.reset.user').subscribe(() => {
      this.chargebeeProfile = undefined;
    });
  }

  public async openPortal() {
    this.chargebeeInstance.logout();
    this.chargebeeInstance.closeAll();
    if(!this.userService.checkPermission(PermissionActions.MANAGE_BILLING)){
      this.logger.error('User does not have permission to manage billing');
      return;
    }
    try {
      this.chargebeeInstance.setPortalSession(() => {
        return this.apiService.execute<any>('chargebeesession', {}).then((response) => response.portal_session);
      });
      this.chargebeeInstance.createChargebeePortal().open({
        subscriptionChanged: async (data) => {
          this.chargebeeInstance.closeAll();
          const fromfree = this.userService.get('is_free_plan');
          this.router.navigate(['success'], {
            queryParams: {
              sub_id: data?.subscription?.id,
              type: 'upgrade',
              user_id: this.userService.get('id'),
              fromfree
            }
          })
        },
        scheduledCancellationRemoved: async () => {
          this.refreshEntitlements();
          this.logger.info('Scheduled cancellation removed, refreshing entitlements');
        },
      });
    } catch (ex) {
      console.error(ex);
    }
  }

  public getSubscription() {
    if (!this.isLoading && !this.chargebeeProfile) {
      this.isLoading = true;
      if (this.isLoading) {
        this.store.dispatch(
          new ChargebeeActions.ChargebeeGetAction()
        );
      } else {
        this.store.dispatch(
          new ChargebeeActions.ChargebeeSuccessAction({
            cprofile: undefined
          })
        );
      }
    }
    return this.store.select(fromRoot.getChargebeeState);
  }

  public refreshSubscription() {
    this.store.dispatch(
        new ChargebeeActions.ChargebeeGetAction()
    );
  }

  public async getChargebeeProfile(): Promise<{ cprofile: cAccountInfo } | null> {
    const retval = await this.apiService.execute<ChargeBeeProfileApiOutput>('chargebeesubscriptiondetails', {}, true);
    this.userLimit = retval?.cprofile?.subscription?.user_limit || 0;
    return (retval.cprofile?.subscription) ? {
      cprofile: retval?.cprofile
    } : null;
  }

  public refreshEntitlements = async () => {
    await this.apiService.execute('syncentitlements', {})
    this.refreshSubscription();
    this.userService.refresh();
  }
}
